import { alpha, Theme } from "@mui/material";
import { TreeItem } from "../data/tree";

const useStyles = (theme: Theme) => ({
  innerButtonStyles: {
    padding: "var(--grid)",
    paddingRight: 10,
    alignItems: "center",
    display: "flex",
    width: "100%",
    flexDirection: "row" as React.CSSProperties["flexDirection"],
    //   background: token("color.background.neutral.subtle", "transparent"),
    borderRadius: 3,
  },
  innerDraggingStyles: { opacity: 0.4 },
  outerButtonStyles: (item: TreeItem, instruction: any) => ({
    "--grid": "8px",
    color: theme.palette.text.primary,
    border: "0",
    width: "100%",
    position: "relative" as const,
    // background: "transparent",
    margin: "0",
    padding: "0",
    borderRadius: "6px",
    cursor: "pointer",

    backgroundColor: item.children.length
      ? alpha(theme.palette.text.secondary, 0.1)
      : "transparent",
    ...(instruction &&
    (instruction.type === "make-child" || instruction.type === "reparent")
      ? { border: `1px solid ${theme.palette.primary.main}` }
      : undefined),
  }),
  parentOfInstructionStyles: {
    background: alpha(theme.palette.primary.main, 0.1),
  },
  outerStyles: {
    // needed for our action button that uses position:absolute
    position: "relative",
    // "--grid": "8px",
    margin: "3px 0 3px 0",
    "&:hover": {
      backgroundColor: alpha(theme.palette.text.secondary, 0.2),
    },
  },
  outerHoverStyles: {
    borderRadius: "6px",
    // backgroundColor: "red",
    cursor: "pointer",
    "&:hover": {
      //   backgroundColor: "red",
      // backgroundColor: alpha(theme.palette.text.secondary, 0.1),
    },
  },
  idStyles: {
    margin: 0,
    color: theme.palette.text.secondary,
  },
  debugStyles: {
    position: "absolute" as const,
    right: "var(--grid)",
    bottom: 0,
    fontSize: "10px",
  },
  labelStyles: (item: TreeItem) => ({
    color: item.children.length
      ? theme.palette.text.primary
      : theme.palette.text.secondary,
    flexGrow: 1,
    overflow: "hidden",
    textAlign: "left" as const,
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  }),
  previewStyles: {
    // "--grid": "8px",
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.text.secondary,
    padding: 2,
    display: "flex",
    flexDirection: "row" as const,
    alignItems: "center",
    justifyContent: "center",
    // padding: "var(--grid)",
    borderRadius: 3,
    paddingRight: 10,
  },
});

export default useStyles;
